import React from 'react';

import { AddCircle } from '@mui/icons-material';
import { Masonry as MuiMasonry } from '@mui/lab';
import {
  Box,
  styled,
  Button,
  Typography
} from '@mui/material';
import imgBackground from 'assets/images/background_my_fundraises.svg';
import _ from 'lodash';
import {
  appEvents,
  AuthWrapper,
  activityTemplates,
  FundraiseCard,
  LoadingOverlay
} from 'modules';

import * as dataService from './dataService';



const Masonry = styled(MuiMasonry)({
  '&.MuiMasonry-root': {
    alignContent: 'flex-start'
  }
});

const HeaderBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(10)
}));

const TypographyBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  maxWidth: 700
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));



export interface IMyFundraisesActivityProps {}

export const MyFundraisesActivity: React.FC<IMyFundraisesActivityProps> = props => {
  const { fnRunQuery, loading, data } = dataService.useMyFundraisesActivity();



  React.useEffect(() => {
    fnRunQuery();
  }, [fnRunQuery]);



  return (
    <AuthWrapper.FC>
      <activityTemplates.BaseActivityTemplate.FC
        imgBackground={imgBackground}
        backgroundColor='#DAE5EB'
        colorVariant="dark">
        <LoadingOverlay active={loading} />

        <HeaderBox>
          <TypographyBox maxWidth={700}>
            <TitleTypography variant="h1" color="#F0F7FA">My Fundraises</TitleTypography>

            <Box>
              <Typography
                fontSize={20}
                color="#C3D1D8">
              Create and track your fundraises here based on the investors you favorite.
              </Typography>

              <Typography
                fontSize={20}
                color="#C3D1D8">
              Keep track of where each investor is in the process via stages and notes.
              </Typography>
            </Box>
          </TypographyBox>

          <Box>
            <Button
              startIcon={<AddCircle />}
              variant="contained"
              color="primary"
              onClick={() => {
                appEvents.broadcast({
                  type: 'modal',
                  args: { type: 'createFundraisingCampaign' },
                  onClose: () => {
                    fnRunQuery();
                  }
                });
              }}>
            Create a fundraise
            </Button>
          </Box>
        </HeaderBox>

        <Masonry columns={3} spacing={2}>
          {!loading && _.map(data, d =>
            <FundraiseCard.FC
              key={d.id}
              variant="summary"
              campaignSummary={d} />
          )}
        </Masonry>
      </activityTemplates.BaseActivityTemplate.FC>
    </AuthWrapper.FC>
  );
};
